/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */
import('./src/styles/styles.scss');
import React from 'react';

import {
    FilterLabelsCat,
    FilterLabelsDog,
} from './src/components/molecules/BreedFilters/breedModel';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { isGeneralPageWithWebform } from './src/components/utils/generalPageHelpers';

export const wrapPageElement = ({ element, props }) => {
    const hasWebform = isGeneralPageWithWebform(props.data);
    if (hasWebform) {
        return (
            <GoogleReCaptchaProvider
                key='recaptcha_b'
                useEnterprise={true}
                reCaptchaKey={process.env.GATSBY_RECAPTCHA_SITE_KEY}
            >
                {element}
            </GoogleReCaptchaProvider>
        );
    } else {
        return element;
    }
};

//a function that checks if the search param string contains a specific key
const hasKey = (search, key) => {
    const params = new URLSearchParams(search);
    return params?.has(key);
};

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
    const { search } = location;

    const catValues = Object.values(FilterLabelsCat);
    const dogValues = Object.values(FilterLabelsDog);
    const allBreedFilterKeys = [...catValues, ...dogValues];
    const uniqueBreedFilterKeys = [...new Set(allBreedFilterKeys)];

    // Check and see if we're paginating through results, or using filters, then dont scroll to top
    if (hasKey(search, 'page') || uniqueBreedFilterKeys.some((key) => hasKey(search, key))) {
        return false;
    } else {
        window.scrollTo(0, 0);
    }
};

// updating route update function to push the page view event
export const onRouteUpdate = ({ location }) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'page_view',
        event_params: {
            page_path: location.pathname,
        },
    });
};

export const onClientEntry = () => {
    // Initialize the wrapper only when analytics and withOneTrust are ready
    if (typeof window === 'undefined') return;

    const hasWrapper = typeof window.withOneTrust === 'function';
    const hasAnalytics = !!window.analytics;

    if (!hasWrapper) {
        console.info('[consent] Skipping wrapper: window.withOneTrust not available');
        return;
    }

    if (!hasAnalytics) {
        console.info('[consent] Skipping wrapper: window.analytics not available');
        return;
    }

    try {
        // If Segment exposes ready, wait until it's ready before initializing
        if (typeof window.analytics.ready === 'function') {
            window.analytics.ready(() => {
                try {
                    window
                        .withOneTrust(window.analytics)
                        .load(process.env.GATSBY_TWILIO_SEGMENT_WRITE_KEY);
                } catch (err) {
                    console.warn('[consent] Wrapper init failed in ready:', err);
                }
            });
        } else {
            window.withOneTrust(window.analytics).load(process.env.GATSBY_TWILIO_SEGMENT_WRITE_KEY);
        }
    } catch (err) {
        console.warn('[consent] Wrapper init failed:', err);
    }
};
